import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
    handleDropboxOAuthCallback,
    validateEnvironmentBeforeBootstrap,
} from '@quipex/core/config';
import { App } from './app/app';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

function setBootstrapErrorState(): void {
    const rootElement = document.querySelector('qpx-root');
    if (rootElement) {
        rootElement.classList.add('qpx-bootstrap-error');
    }

    document.dispatchEvent(new Event('qpx:startup-error'));
}

if (!handleDropboxOAuthCallback()) {
    try {
        validateEnvironmentBeforeBootstrap(environment);

        if (environment.env === 'production') {
            enableProdMode();
        }

        bootstrapApplication(App, appConfig)
            .then(() => {
                document.dispatchEvent(new Event('qpx:startup-ready'));
            })
            .catch((err) => {
                setBootstrapErrorState();
                console.error(err);
            });
    } catch (err) {
        setBootstrapErrorState();
        console.error(err);
        throw err;
    }
}
